import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import router from "./router";
import i18n from "./plugins/i18n";
import "./plugins";
import "./ui_components";
import { sync } from 'vuex-router-sync';

import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify";
Vue.use(Vuetify);
sync(store, router)

Vue.config.productionTip = false;
import "./utils/filters";

new Vue({
  vuetify,
  i18n,
  store,
  router,
  ...App
}).$mount('#app')
